import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Row, Col, Button, Modal } from 'react-bootstrap';
import { ITermsConditionData } from '../../models/login';
import { Helmet } from 'react-helmet';
import images from '../../assets/images';
import { companyNameReplace } from '../../utils';
import { useAcceptTermsAndCondition } from './hooks/AcceptTermsAndConditionHook';

export const AcceptTermsAndCondition = () => {
    const maxHeight = 350;
    const {
        userData,
        termsConditionList,
        selectedTermsAndCondition,
        isReachedToBottom,
        modal,
        trackScrolling,
        handleSubmit,
        acceptTermsCondition,
        handleModal,
        handleCheckChange,
    } = useAcceptTermsAndCondition();
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{companyNameReplace(t('termsAndConditionListing.title'))} </title>
            </Helmet>
            <div className="login-page p-0 no-gutters container-fluid clearfix">
                <Row className="row no-gutters min-h-100 align-items-center">
                    <Col>
                        <div className="login-outer">
                            <div className="login-block">
                                <a className="logo" href="/" title={t<string>('login.button.instavolt')}>
                                    <img
                                        className="d-block"
                                        src={images.adminLogoPNG}
                                        alt={t<string>('login.button.instavolt')}
                                    />
                                </a>
                                <h1 className="title">{companyNameReplace(t('login.loginForm.header'))}</h1>

                                {userData && userData.has_saved_terms ? (
                                    <div className="form-group mb-0">
                                        <p>{t('termsAndConditionListing.label.reviewUpdatedCondition')}</p>
                                    </div>
                                ) : (
                                    <div className="form-group mb-0">
                                        <p className="text-center">
                                            {t('termsAndConditionListing.label.termsAndConditions')}
                                        </p>
                                    </div>
                                )}

                                <form className="tac-form form-secondary" autoComplete="off">
                                    {termsConditionList.length > 0 &&
                                        termsConditionList.map((data: ITermsConditionData, index: number) => {
                                            return (
                                                <Form.Group key={index} className="form-group">
                                                    <div className="custom-control custom-checkbox custom-control-inline d-flex align-items-center">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id={`tc${data.id}`}
                                                            name="termsCondition"
                                                            checked={selectedTermsAndCondition.includes(data.id)}
                                                            onChange={() => handleCheckChange(data)}
                                                        />
                                                        <label
                                                            className="custom-control-label pb-0"
                                                            htmlFor={`tc${data.id}`}
                                                        >
                                                            {t(
                                                                'termsAndConditionListing.label.iAggreeToTermsCondition',
                                                            )}
                                                        </label>
                                                        <span
                                                            onClick={() =>
                                                                handleModal(data.content, data.name, true, data.id)
                                                            }
                                                            className="term-and-condition"
                                                        >
                                                            {`${data.name} ${data.mandatory ? '*' : ''}`}
                                                        </span>
                                                    </div>
                                                </Form.Group>
                                            );
                                        })}

                                    <p>
                                        <span className="themeColor">{t('termsAndConditionListing.label.note')}</span>
                                        {t('termsAndConditionListing.noteDetails')}
                                    </p>
                                    <Form.Group className="form-group">
                                        <Button onClick={handleSubmit} className="w-100">
                                            <span>{t('termsAndConditionListing.button.next')}</span>
                                        </Button>
                                    </Form.Group>
                                </form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <Modal show={Boolean(modal.showModal)} onHide={() => handleModal('', '', null, null)}>
                <Modal.Header closeButton>
                    <Modal.Title>{modal.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div
                        onScroll={trackScrolling}
                        id="terms_condition"
                        data-testid="terms_condition"
                        style={{ maxHeight: maxHeight, overflow: 'auto' }}
                        dangerouslySetInnerHTML={{
                            __html: String(modal.body),
                        }}
                    ></div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={!isReachedToBottom}
                        className="btn btn-primary"
                        onClick={() => {
                            acceptTermsCondition(Number(modal.id));
                        }}
                        title={t<string>('termsAndConditionListing.button.accept')}
                    >
                        <span>{t('termsAndConditionListing.button.accept')}</span>
                    </Button>
                    <Button
                        className="btn btn-secondary"
                        onClick={() => handleModal('', '', false, null)}
                        title={t<string>('termsAndConditionListing.button.cancel')}
                    >
                        <span>{t('termsAndConditionListing.button.cancel')}</span>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
export default AcceptTermsAndCondition;
